import { HttpClient } from '../clientFactory/unpack/types'

import MyPageActions from './myPageClient/myPageActions'

const MyPageClient = (client: HttpClient) => new MyPageActions(client)
export default MyPageClient
